import { WarningAmber } from "@mui/icons-material";
import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { useRideValidators } from "@ryde/redux";
import {
  IStationInfo,
  NO_VALUE_DISPLAY,
  translateInfoItem,
} from "@ryde/shared";

import { FramerTooltip } from "../../../tooltips";
import { RideStationWarningContentWrapperStyled } from "./ride-stations.styled";

interface IRideStationWarningContent {
  station: IStationInfo | undefined;
}

export const RideStationWarningContent: FC<IRideStationWarningContent> = ({
  station,
}) => {
  const { t } = useTranslation();
  const { validateStationInfo } = useRideValidators();
  const validationItemText = useMemo(() => {
    const validateResult = validateStationInfo(station);
    return validateResult.success
      ? false
      : (validateResult.data
          ?.map(item => translateInfoItem(item, t))
          ?.join(",") ?? NO_VALUE_DISPLAY);
  }, [station, t, validateStationInfo]);
  return (
    validationItemText && (
      <RideStationWarningContentWrapperStyled>
        <FramerTooltip content={validationItemText}>
          <WarningAmber className="ride_station--warning" />
        </FramerTooltip>
      </RideStationWarningContentWrapperStyled>
    )
  );
};
